import { classnames } from 'tailwindcss-classnames';
import { HitType } from './Hits/_types';
import { useSearchDictionary } from './util';
import { DiseaseFilterProps } from 'components/helpers/NmdpSite/TCDirectorySearch/_types';
import { useScreenBreakpoint } from 'lib/util/useScreenWidth';
import { Td, Tr } from 'react-super-responsive-table';
import LinkA11yWrapper from '../LinkA11yWrapper';

export const TcDirectoryHit = ({ hit, txId }: DiseaseFilterProps) => {
  const dict = useSearchDictionary();
  const { isMediumScreen } = useScreenBreakpoint(); // >= 765px (was > 767px)
  const TcHit = hit as HitType;
  const tdClass = classnames('p-2.5', 'border', 'border-gray-quartz');
  const trClass = classnames(
    'p-2.5',
    'even:bg-gray-whisper',
    'mb-2',
    'sm:mb-0',
    'border',
    'border-gray-quartz'
  );
  const headlineClass = classnames(
    'text-blue',
    'text-base',
    'leading-4',
    'mb-2',
    'line-clamp-3',
    'sm:leading-6',
    'md:line-clamp-1',
    'font-semibold'
  );
  const getSurvivorship = (data: string) => {
    return data === '1' ? 'Yes' : 'No';
  };

  const pageUrl = txId ? `${TcHit.url}?txId=${txId}` : TcHit.url;
  const title = TcHit.pageTitle;
  const programType =
    TcHit.programType === 'Pediatric/Adult' ? 'Pediatric and Adult' : TcHit.programType;
  return (
    <>
      {isMediumScreen ? (
        <Tr className={trClass}>
          <Td className={tdClass}>
            <h3 className={headlineClass}>
              <LinkA11yWrapper field={{ text: title, href: pageUrl, target: '_self' }} />
            </h3>
          </Td>
          <Td className={tdClass}>{TcHit.city}</Td>
          <Td className={tdClass}>{TcHit.state}</Td>
          <Td className={tdClass}>{TcHit.totalAllos}</Td>
          <Td className={tdClass}>{programType}</Td>
          <Td className={tdClass}>{getSurvivorship(TcHit.survivorshipProgram)}</Td>
        </Tr>
      ) : (
        <div
          className={classnames(
            'flex-col',
            'border',
            'border-gray-solitude',
            'text-solidBlack',
            'p-4',
            'tc-hit-mobile'
          )}
        >
          <h3 className={headlineClass}>
            <LinkA11yWrapper field={{ text: title, href: pageUrl, target: '_self' }} />
          </h3>
          <div className={classnames('text-solidBlack')}>
            {TcHit.city}, {TcHit.state}
          </div>
          <div>
            <span className={classnames('font-semibold')}>{dict.allos}: </span>
            {TcHit.totalAllos}
          </div>
          <div>
            <span className={classnames('font-semibold')}>{dict.programType}: </span>
            {TcHit.programType}
          </div>
          <div>
            <span className={classnames('font-semibold')}>{dict.survivorShip}: </span>
            {getSurvivorship(TcHit.survivorshipProgram)}
          </div>
        </div>
      )}
    </>
  );
};
